import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import {
    CREATE_PROJECT_SERVICES,
    get_headers,
    GET_ALL_PROJECT_SERVICES,
    UPDATE_PROJECT_SERVICE,
    GET_COMPANIES
} from '@/utils/constants/constants.js';
import axios from 'axios';
import $ from 'jquery';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';


export default {
    name: 'ServiceManagement',
    mixins: [alert_mixin, formatting_mixins],
    data: () => ({
        headers: get_headers(),
        project_id: sessionStorage.getItem('project_id'),
        current_service: {
            id: null,
            service_name: '',
            service_description: '',
            price: '',
            vat_inclusive: true,  // selected by default
            vat_exempt: true
        },
        service_forms: [],
        table_safe_form_list: [],
        form_table_headers: [],
        selected_project_id: '',
        projects: [],   
    }),

    methods: {
        open_create_modal() {
            this.current_service = {
                id: null,
                service_name: '',
                service_description: '',
                price: '',
                vat_inclusive: true,
                vat_exempt: false
            };
        },

        open_edit_modal(service) {
            this.current_service = {
                id: service.id,
                service_name: service.name,
                service_description: service.description,
                price: service.price,
                vat_inclusive: service.vat_inclusive,
                vat_exempt: service.vat_exempt
            };
        },

        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },


        get_services() {
            this.destroy_data_table();
            this.service_forms = [];

            var query_params = {
                project_id: this.project_id,
            };

            axios.get(GET_ALL_PROJECT_SERVICES, {
                headers: this.headers,
                params: query_params
            })
            .then(response => {
                const parsed_response = response.data;
                if (parsed_response.data && parsed_response.data.length > 0) {
                    this.service_forms = parsed_response.data;
                    this.transform_forms_data();
                } else {
                    this.forms = [];
                }
            })
            .catch(error => {
                this.show_error('Error getting forms: ' + (error.response?.data?.message || error.message));
                this.service_forms = [];
            });
        },

        get_projects() {

            axios.get(GET_COMPANIES, { headers: this.headers })
                .then(response => {

                    const parsed_response = JSON.parse(response.data);

                    if (parsed_response.status === 'success') {
                        this.projects = parsed_response.data.map(project => ({
                            id: project.id,
                            name: project.name
                        }));
                    } else {
                        this.projects = [];
                    }
                })
                .catch(error => {
                    const message = error.response?.data?.message || error.message;
                    this.show_error('Failed to fetch projects: ' + message);
                    this.projects = [];
                });
        },



        handle_project_selection() {
            sessionStorage.setItem('project_id', this.project_id);
            this.get_services();
        },



        transform_forms_data() {
            if (this.service_forms.length > 0) {
                const TABLE_FORM_DATA = this.service_forms.map(form => ({
                    id: form.id,
                    name: form.name || form.form_name,
                    description: form.description || form.form_description,
                    last_modified: this.format_date(form.last_modified || form.date_created),
                    price: form.price,
                    vat_inclusive: form.vat_inclusive,
                    vat_exempt: form.vat_exempt,
                    date_created: form.date_created
                }));

                this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_form_list = TABLE_FORM_DATA;
            } else {
                this.table_safe_form_list = [];
            }

            this.$nextTick(() => {
                this.initialize_data_table();
            });
        },


        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#forms_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }
                
                // Destroy the existing DataTable instance if it exists
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }
                
                // Store the DataTable instance
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        async create_service() {
            if (!validate_non_empty_string(this.current_service.service_name)) {
                this.show_error('Service name is required.');
                return;
            }
        
            if (this.current_service.service_description !== '') {
                if (!validate_non_empty_string(this.current_service.service_description)) {
                    this.show_error('Service description is required.');
                    return;
                }
            }

            const payload = {
                project_id: this.project_id,
                name: this.current_service.service_name,
                description: this.current_service.service_description,
                price: this.current_service.price,
                vat_inclusive: this.current_service.vat_inclusive,
                vat_exempt: this.current_service.vat_exempt
            };

            axios.post(CREATE_PROJECT_SERVICES, payload, { headers: this.headers })
                .then(response => {
                    const response_data = response.data;

                
                    const { status, message } = response_data;
                    if (status === 'success') {
                        this.close_modal('create_service');
                        this.show_success('Service created successfully.');
                        window.location.reload();
                    } else {
                        this.show_error('Error creating service: ' + (message || 'Unknown error'));
                        this.close_modal('create_form');
                    }
                })
                .catch(error => {
                    this.show_error('Error creating service: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                    this.close_modal('create_service');
                });
        },

        async update_service() {
   
            const payload = {
                service_id: this.current_service.id,
                name: this.current_service.service_name,
                description: this.current_service.service_description,
                price: this.current_service.price,
                vat_inclusive: this.current_service.vat_inclusive,
                vat_exempt: this.current_service.vat_exempt

            };

            
            axios.post(UPDATE_PROJECT_SERVICE, payload, { headers: this.headers })
                .then(response => {
                    const response_data = response.data;
                    const { status, message } = response_data;

                    if (status === 'success') {
                        this.close_modal('edit_service');
                        this.get_services();
                        this.show_success('Service updated successfully.');
                    } else {
                        this.show_error('Error updating service: ' + (message || 'Unknown error'));
                        this.close_modal('edit_service');
                    }
                })
                .catch(error => {
                    this.show_error('Error updating form: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                    this.close_modal('edit_service');
                });

        }
    },

    computed: {
        sorted_services() {
            return [...this.table_safe_form_list].sort((a, b) => {
                return new Date(b.last_modified) - new Date(a.last_modified);
            });
        }
    },

    mounted() {
        this.get_projects();      // Load available projects first
        if (this.project_id) {
            this.selected_project_id = this.project_id;
            this.get_services();  // Load services only if a project was previously selected
        }
    }
};
